"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaObjectMixin = void 0;
var _drywall = require("drywall");
var _styledComponents = require("styled-components");
var _ie11Mixin = require("../ie11Mixin");
var _spaceMixin = require("../spaceMixin");
var _spacingMixin = require("../spacingMixin");
var ALIGN = {
  top: 'flex-start',
  start: 'flex-start',
  center: 'center',
  bottom: 'flex-end',
  end: 'flex-end'
};
var reverseCSS = function reverseCSS(props) {
  var reverse = props.reverse,
    gutter = props.gutter;
  if (!reverse) {
    return '';
  }
  return (0, _styledComponents.css)(["", "{order:2;margin-right:0;margin-left:", ";}"], _drywall.MediaObject.Media, (0, _spaceMixin.spaceMixin)(gutter));
};
var ieCSS = /*#__PURE__*/(0, _styledComponents.css)(["", ",", "{max-width:100%;min-width:1px;}"], _drywall.MediaObject.Media, _drywall.MediaObject.Body);

/** @class MediaObjectMixin */
/** @method */
var MediaObjectMixin = function MediaObjectMixin(props) {
  var align = props.align,
    direction = props.direction,
    gutter = props.gutter;
  return (0, _styledComponents.css)(["display:flex;flex-direction:", ";align-items:", ";", "{margin-", ":", ";}", "{flex-grow:1;}", " ", " ", ""], direction, ALIGN[align], _drywall.MediaObject.Media, direction === 'row' ? 'right' : 'bottom', (0, _spaceMixin.spaceMixin)(gutter)(props), _drywall.MediaObject.Body, (0, _ie11Mixin.ie11Mixin)(ieCSS), reverseCSS(props), (0, _spacingMixin.spacingMixin)(props));
};
exports.MediaObjectMixin = MediaObjectMixin;